import NewSocialCampaign from '@apps/campaigns/admin/views/social/new'
import NewEmailCampaign from '@apps/campaigns/admin/views/email/new'
import MJSONScreenshot from '@admin/components/mjson_screenshot'
import ProgramForm from '@apps/crm/admin/components/programform'
import Container from '@admin/components/container'
import { Mail, MessageSquare } from 'lucide-react'
import Button from '@admin/components/button'
import Avatar from '@admin/components/avatar'
import T from '@admin/components/t' 
import PropTypes from 'prop-types'
import React from 'react'

class Card extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    manager: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    config: PropTypes.object,
    daterange: PropTypes.object,
    data: PropTypes.object,
    isExpanded: PropTypes.bool,
    program: PropTypes.object,
    service: PropTypes.object,
    showChart: PropTypes.bool,
    showTable: PropTypes.bool
  }

  render() {
    const { user } = this.context.admin
    const { data } = this.props
    if(!data) return null
    return (
      <div className="truevail-start-card">
        <div className="truevail-start-card-header">
          <div className="truevail-start-card-header-left">
            <div className="truevail-start-card-avatar">
              <Avatar user={ user } width={ 120 } presence={ false } />
            </div>
            <div className="truevail-start-card-greeting">
              <h1>Hello { user.first_name },</h1>
              <p><T text="t(What would you like to do today?)" /></p>
            </div>
          </div>
          <div className="truevail-start-card-header-right">
            <div className="truevail-start-card-logo">
              <img src="/images/truevail-logotype-black.png" />
            </div>
          </div>
        </div>
        <div className="truevail-start-card-grid">
          <div className="truevail-start-card-row">
            <div className="truevail-start-card-item create-card email">
              <h3><T text="t(Create Email Campaign)" /></h3>
              <p><T text="t(Send a custom email or start from the content library.)" /></p>
              <Button { ...this._getCreateEmailCampaign() } />
              <div className="truevail-start-card-link">
                <Button { ...this._getEmailContentLibrary() } />
              </div>
            </div>
            <div className="truevail-start-card-item stats-card email">
              <div className="truevail-start-card-card-header">
                <div className="truevail-start-card-icon-badge email">
                  <Mail size={ 24 } />
                </div>
                <div className="truevail-start-card-card-title">
                  <h3><T text="t(Email Campaigns)" /></h3>
                  <p className="subtitle"><T text="t(Scheduled and Draft Posts)" /></p>
                </div>
              </div>
              <div className="truevail-start-card-stats">
                <div className="truevail-start-card-stat-item">
                  <div className="stat-value">{ data.email_campaign_scheduled }</div>
                  <div className="stat-label"><T text="t(Scheduled)" /></div>
                </div>
                <div className="truevail-start-card-stat-item">
                  <div className="stat-value">{ data.email_campaign_drafts }</div>
                  <div className="stat-label"><T text="t(Drafts)" /></div>
                </div>
              </div>
              <div className="truevail-start-card-link">
                <Button { ...this._getAllEmailCampaigns() } />
              </div>
            </div>
            { data.email_campaign_recent ?
              <div className="truevail-start-card-item recent-card email">
                <div className="truevail-start-card-card-header">
                  <div className="truevail-start-card-card-screenshot">
                    <MJSONScreenshot { ...this._getEmailCampaignScreenshot(data.email_campaign_recent) } />
                  </div>
                  <div className="truevail-start-card-card-title">
                    <h3><T text="t(Recent Email Performance)" /></h3>
                    <p className="subtitle">{ data.email_campaign_recent.title }</p>
                  </div>
                </div>
                <div className="truevail-start-card-stats">
                  <div className="truevail-start-card-stat-item">
                    <div className="stat-value">{ this._formatPercent(data.email_campaign_recent.open_rate) }</div>
                    <div className="stat-label"><T text="t(Open Rate)" /></div>
                  </div>
                  <div className="truevail-start-card-stat-item">
                    <div className="stat-value">{ this._formatPercent(data.email_campaign_recent.click_rate) }</div>
                    <div className="stat-label">Click Rate</div>
                  </div>
                </div>
                <div className="truevail-start-card-link">
                  <Button { ...this._getEmailAnalaytics() } />
                </div>
              </div> :
              <div className="truevail-start-card-item recent-card email">
                <div className="truevail-start-card-card-header">
                  <div className="truevail-start-card-card-title">
                    <h3><T text="t(No Recent Email)" /></h3>
                  </div>
                </div>
                <div className="truevail-start-card-stats">
                  <div className="truevail-start-card-stat-item">
                    <div className="stat-value">0%</div>
                    <div className="stat-label"><T text="t(Open Rate)" /></div>
                  </div>
                  <div className="truevail-start-card-stat-item">
                    <div className="stat-value">0%</div>
                    <div className="stat-label">Click Rate</div>
                  </div>
                </div>
                <div className="truevail-start-card-link">
                  <Button { ...this._getEmailAnalaytics() } />
                </div>
              </div>
            }
          </div>
          <div className="truevail-start-card-row">
            <div className="truevail-start-card-item create-card social">
              <h3><T text="t(Create Social Campaign)" /></h3>
              <p><T text="t(Schedule posts or customize ready to post content.)" /></p>
              <Button { ...this._getCreateSocialCampaign() } />
              <div className="truevail-start-card-link">
                <Button { ...this._getSocialContentLibrary() } />
              </div>
            </div>
            <div className="truevail-start-card-item stats-card social">
              <div className="truevail-start-card-card-header">
                <div className="truevail-start-card-icon-badge social">
                  <MessageSquare size={ 24 } />
                </div>
                <div className="truevail-start-card-card-title">
                  <h3><T text="t(Social Campaigns)" /></h3>
                  <p className="subtitle"><T text="t(Scheduled and Draft Posts)" /></p>
                </div>
              </div>
              <div className="truevail-start-card-stats">
                <div className="truevail-start-card-stat-item">
                  <div className="stat-value">{ data.social_campaign_scheduled }</div>
                  <div className="stat-label"><T text="t(Scheduled)" /></div>
                </div>
                <div className="truevail-start-card-stat-item">
                  <div className="stat-value">{ data.social_campaign_drafts }</div>
                  <div className="stat-label"><T text="t(Drafts)" /></div>
                </div>
              </div>
              <div className="truevail-start-card-link">
                <Button { ...this._getAllSocialCampaigns() } />
              </div>
            </div>
            { data.social_campaign_recent ?
              <div className="truevail-start-card-item recent-card social">
                <div className="truevail-start-card-card-header">
                  <div className="truevail-start-card-card-screenshot">
                    <MJSONScreenshot { ...this._getSocialCampaignScreenshot(data.social_campaign_recent?.variants?.[0]) } />
                  </div>
                  <div className="truevail-start-card-card-title">
                    <h3><T text="t(Recent Social Performance)" /></h3>
                    <p className="subtitle">{ data.social_campaign_recent.title }</p>
                  </div>
                </div>
                <div className="truevail-start-card-stats">
                  <div className="truevail-start-card-stat-item">
                    <div className="stat-value">{ data.social_campaign_recent.impressions }</div>
                    <div className="stat-label"><T text="t(Impressions)" /></div>
                  </div>
                  <div className="truevail-start-card-stat-item">
                    <div className="stat-value">{ data.social_campaign_recent.reactions }</div>
                    <div className="stat-label"><T text="t(Reactions)" /></div>
                  </div>
                </div>
                <div className="truevail-start-card-link">
                  <Button { ...this._getSocialAnalaytics() } />
                </div>
              </div> :
              <div className="truevail-start-card-item recent-card social">
                <div className="truevail-start-card-card-header">
                  <div className="truevail-start-card-card-title">
                    <h3><T text="t(No Recent Social Campaign)" /></h3>
                  </div>
                </div>
                <div className="truevail-start-card-stats">
                  <div className="truevail-start-card-stat-item">
                    <div className="stat-value">0</div>
                    <div className="stat-label"><T text="t(Impressions)" /></div>
                  </div>
                  <div className="truevail-start-card-stat-item">
                    <div className="stat-value">0</div>
                    <div className="stat-label"><T text="t(Reactions)" /></div>
                  </div>
                </div>
                <div className="truevail-start-card-link">
                  <Button { ...this._getSocialAnalaytics() } />
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }

  _formatPercent(value) {
    return `${Math.round(value * 100)}%`
  }

  _getEmailCampaignScreenshot(entity) {
    return {
      engine: 'mjson',
      entity: `campaigns_email_campaigns/${entity.code}`,
      width: 100,
      height: 75,
      screenshoted_at: entity.screenshoted_at
    }
  }

  _getSocialCampaignScreenshot(entity) {
    return {
      engine: 'mjson',
      entity: `campaigns_social_campaign_variants/${entity.code}`,
      width: 100,
      height: 75,
      screenshoted_at: entity.screenshoted_at
    }
  }

  _getAllEmailCampaigns() {
    return {
      label: 't(View all Email Campaigns) >',
      className: 'link',
      route: '/admin/campaigns/email'
    }
  }

  _getAllSocialCampaigns() {
    return {
      label: 't(View all Social Campaigns) >',
      className: 'link',
      route: '/admin/campaigns/social'
    }
  }

  _getCreateEmailCampaign() {
    return {
      label: '+ t(Create Email) ',
      modal: <ProgramForm form={ NewEmailCampaign } />
    }
  }

  _getCreateSocialCampaign() {
    return {
      label: '+ t(Create Post)',
      color: 'gold',
      modal: <ProgramForm form={ NewSocialCampaign } />
    }
  }

  _getEmailContentLibrary() {
    return {
      label: 't(Browse Content Library) >',
      className: 'link',
      modal: <ProgramForm form={ NewEmailCampaign } props={{ strategy: 'email_campaign' }} />
    }
  }

  _getSocialContentLibrary() {
    return {
      label: 't(Browse Content Library) >',
      className: 'link',
      modal: <ProgramForm form={ NewSocialCampaign } props={{ strategy: 'truevail' }} />
    }
  }

  _getEmailAnalaytics() {
    return {
      label: 't(View all Email Analytics) >',
      className: 'link',
      handler: () => {
        this.context.manager.change('1')
      }
    }
  }

  _getSocialAnalaytics() {
    return {
      label: 't(View all Social Analytics) >',
      className: 'link',
      handler: () => {
        this.context.manager.change('2')
      }
    }
  }

}

const mapResources = (props) => ({
  data: {
    endpoint: '/api/admin/dashboards/truevail/advisor_start/card',
    filter: {
      daterange: props.daterange
    }
  }
})

export default Container(mapResources)(Card)
